(function($) {
	
	$('.archive-pagination').hide();
	$('.content').infinitescroll({
	    loading: {
	        finishedMsg: 'Everything has loaded.',
	        img: '',
	        msgText: 'Loading...',
	    },
	    nextSelector: '.archive-pagination .pagination-next a',
	    navSelector: '.archive-pagination',
	    itemSelector: '.content .entry'
	});
	
})(jQuery);